import store from '../store'

// Rotas que não devem disparar tentativa de refresh em caso de 401
const NO_REFRESH_URLS = ['/login', '/refresh', '/register']

// Várias requisições da mesma tela podem voltar 403/401 juntas: navega uma vez só
// (antes: "NavigationDuplicated: Avoided redundant navigation to /semPermissao")
function pushRoute(route) {
    const router = window._Vue.$router
    const current = router.currentRoute || {}
    if (current.name === route.name) return
    const navegacao = router.push(route)
    if (navegacao && navegacao.catch) navegacao.catch(() => {})
}

export default () => {
    return ({ status, url }) => {
        if (status === 401) {
            // Se o 401 veio do login, do refresh ou do cadastro, apenas ignora.
            // Caso contrário, causaria loop infinito (refresh retornando 401 dispara
            // novo refresh, que retorna 401, ad infinitum) ou signout indevido
            // durante uma tentativa de login com senha errada.
            const isAuthEndpoint = NO_REFRESH_URLS.some(path => String(url).includes(path))
            if (isAuthEndpoint) return

            // Para qualquer outra rota, tenta renovar o token antes de deslogar.
            // ActionRefreshToken usa _refreshPromise para garantir uma única chamada
            // simultânea; qualquer falha no refresh faz o catch abaixo deslogar.
            store.dispatch('auth/ActionRefreshToken').catch(() => {
                store.dispatch('auth/ActionSignOut')
                pushRoute({ name: 'login' })
            })
        }

        if (status === 403) {
            pushRoute({ name: 'semPermissao' })
        }
    }
}
